var $d80a27deda7cdb3c$exports = {};
$d80a27deda7cdb3c$exports = {
  "dismiss": "\u53D6\u6D88"
};
export { $d80a27deda7cdb3c$exports as default };